import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getBaseCurrencyCode } from 'utils/helpers/currency/currencyHelpers';
import OffRateHistory from './OffRateHistory';
import OffRateNewRate from './OffRateNewRate';
import type { RateUserNameItem } from './model/types';

type OffRateProps = {
    show: boolean;
    setShow: (show: boolean) => void;
    UserNameItem?: RateUserNameItem | null;
};

const OffRate = ({ show, setShow, UserNameItem = null }: OffRateProps) => {
    const { t } = useTranslation(['Rate']);

    return (
        <Offcanvas placement="end" show={show} onHide={() => setShow(false)}>
            <Offcanvas.Header className="border-bottom" closeButton>
                <Offcanvas.Title>{t('title', { code: getBaseCurrencyCode() })}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="px-0">
                <OffRateNewRate setShow={setShow} />
                <OffRateHistory UserNameItem={UserNameItem} />
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffRate;
